import { render } from "./ProjectFileContentCard.vue?vue&type=template&id=1846b0d4&scoped=true"
import script from "./ProjectFileContentCard.vue?vue&type=script&lang=js"
export * from "./ProjectFileContentCard.vue?vue&type=script&lang=js"

import "./ProjectFileContentCard.vue?vue&type=style&index=0&id=1846b0d4&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1846b0d4"]])

export default __exports__